<template>
  <div class="charts__wrapper">
    <EquivalencyInfoChart :class="{active: active_chart === index}"  v-for="(item, index) in equivalencies" :nearterm_end_year=nearterm_end_year :total_impact=total_impact :impact_data=item />
  </div>

  <div class="chart__navigation">
    <div class="chart__progress-bar">
      <div  :style="marker_styles" class="progress-bar__marker"></div>
    </div>
    <svg-vue v-for="(item, index) in equivalencies" @click="updateActive(index)" :class="{active: active_chart === index}" :icon=item.icon></svg-vue>
  </div>

  <div v-html="sources_caption" class="chart__source copy text--caption"></div>
</template>

<script>

import EquivalencyInfoChart from './EquivalencyInfoChart.vue'

export default {
  name: "Equivalencies",
  components: {EquivalencyInfoChart},
  props: ['id'],
  data() {
    return {
      equivalencies: [],
      nearterm_end_year: 0,
      total_impact: 0,
      sources_caption: '',
      active_chart: 0,
      marker_styles: {
        transform: ''
      }
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.updateActive(0);
  },
  methods: {
    async fetchData() {
      const fetchedData = await fetch(`/api/collections/areas_of_investigation/entries/${this.id}`);
      const { data } = await fetchedData.json();

      const globalFetch = await fetch(`/api/globals/dataviz`);
      const globalData = await globalFetch.json();

      this.equivalencies = [
        {
          impact: data.aoi_nearterm_impact_equivalent_forest,
          equivalent_to: 'carbon sequestered by',
          equivalent_metric: 'acres of US forest in one year',
          legend_rate: 'acres forest',
          icon: 'tree',
          type: ''
        },
        {
          impact:  data.aoi_nearterm_impact_equivalent_electricity,
          equivalent_to: 'CO<sub>2</sub> emissions from',
          equivalent_metric: 'homes\' energy use for one year',
          legend_rate: 'homes',
          icon: 'house',
          type: ''
        },
        {
          impact:  data.aoi_nearterm_impact_equivalent_ghg_footprint,
          equivalent_to: 'the average GHG footprint of',
          equivalent_metric: 'American individuals',
          legend_rate: 'individuals',
          icon: 'person',
          type: ''
        },
        {
          impact:  data.aoi_nearterm_impact_equivalent_percent_us_annual_gdp,
          equivalent_to: '',
          equivalent_metric: 'of annual US sector GHG emissions',
          legend_rate: '',
          icon: 'usgdp',
          type: 'pie'
        }
      ];

      this.nearterm_end_year = globalData.data.nearterm_end_year;
      this.total_impact = data.aoi_nearterm_impact_total_adjusted;
      this.sources_caption = data.sources_caption;
    },
    updateActive (index) {
      this.active_chart = index;
      const marker = document.querySelector(".progress-bar__marker");
      const markerWidth = marker.clientWidth;
      const progressWidth = document.querySelector(".chart__progress-bar").clientWidth - 128;
      const progressStep = progressWidth / (this.equivalencies.length - 1); 

      if (index === 0) {
        this.marker_styles.transform = 'translateX(0)'
      }
      else {
        this.marker_styles.transform = `translateX(${(progressStep * index) + ( index * 32)}px)`
      }
    }
  },
};
</script>